<template>
  <div class="container" >
    <!-- <div class="frameBg"> -->
        <iframe width="100%" :src="src" frameborder="0" security="restricted" sandbox="allow-scripts allow-top-navigation allow-same-origin allow-forms allow-modals"  >
            <!-- <head>style="width: 1px; min-width: 100%; *width: 100%;"
              scrolling="no"
              <meta http-equiv="Content-Type" content="text/html; charset=gbk" />
              <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0">
             </head> -->
        </iframe>
        <!-- <embed class="embedbg" :src="srcFlie" /> -->
        <section class="mail_box" v-if="meetingRoomId && isAgreement==1 ">
          <input type="text" v-model="email" placeholder="请填写可接收的邮箱地址" />
          <span @click="sendmeeting()">发送</span>
        </section>
    <!-- </div> -->
  </div>
</template>

<script>
import util from "../utils/util";
import {meetingSendAgreementEmail } from '../utils/api';

export default {
    name:'iframePage',
    data(){
        return {
            src:'',
            srcFlie:'',
            meetingRoomId:'',
            isAgreement:'',
            agreementName:'',
        }
    },
    created(){
      let src = localStorage.getItem("src");
    //  let src  = 'https://phk1-word-view.officeapps.live.com/wv/mWord.aspx?ui=zh%2DCN&rs=zh%2DCN&WOPISrc=http%3A%2F%2Fphk1%2Dview%2Dwopi%2Ewopi%2Elive%2Enet%3A808%2Foh%2Fwopi%2Ffiles%2F%40%2FwFileId%3FwFileId%3Dhttps%253A%252F%252Fshsaasoss%252Eoss%252Dcn%252Dshanghai%252Ealiyuncs%252Ecom%253A443%252Fspaceup%255Frst%255Ftest%252F1589005669453%252Edocx%253FExpires%253D3165805674%2526OSSAccessKeyId%253DLTAIwmjkKm3OHGdh%2526Signature%253DJVbvmM7El4YFEIVxpDNfMEvLGjc%25253D&access_token_ttl=0&access_token=1&wdMobileHost=2'
      console.log("url  in iframe ===   "   +src);

      this.src = src;
       let url1 = localStorage.getItem("srcFlie");
      this.srcFlie =url1
       this.meetingRoomId = this.$route.query.meetingRoomId ||'';
      this.isAgreement = this.$route.query.isAgreement||'';
      this.agreementName = this.$route.query.agreementName ||'';

},
    // destroyed(){
    //   localStorage.removeItem("src")
    // }
    methods:{
       isEmail(str){
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            ///^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        return reg.test(str);
      },
      sendmeeting(){
         if(!this.isEmail(this.email)){
          util.showToast("请填写正确的邮箱地址~");
          return false;
        }
        console.log("in sendmeeting")
        util.showLoading()
        let params = {
          meetingRoomId:this.meetingRoomId,
          agreementName :this.agreementName ,
          email:this.email,
          path:this.srcFlie,
        }
        meetingSendAgreementEmail(params).then(res=>{
          util.hideLoading()
          if(res.res && res.res.code === 10000){
            this.$router.replace(`/successPage?title=发送成功&desc=已成功发送至电子邮箱，请注意查收~`)
          }else{
            util.showToast(res.res.msg)
          }
        })

      }
    },
};
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.container{
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  box-sizing:border-box;
}
/* .frameBg{
  overflow-y: scroll;
  width: 100%;
  overflow: auto;
  padding-left: 15px;
  padding-right: 15px;
  -webkit-overflow-scrolling:touch;
  box-sizing:border-box;
} */
iframe{
    /* -webkit-overflow-scrolling: touch;
    box-sizing:border-box;
    min-width: 100%;
    *width:100%;
    width:1px; */
    width: 100%;
    height: 90%;

}
.embedbg{
  width: 100%;
  height: 90%;
  background-color: red;
}

.mail_box{
  position:fixed;
  bottom:0;left:0;right:0;
  height:120px;
  background:#fff;
  .flex();
  align-items:center;
  jusctify-content:space-between;
  padding:0 20px;
  input{
    flex:1;
    height:80px;
    border-radius:4px;
    border:2px solid rgba(234,234,234,1);
    font-size:32px;
    padding-left:20px;
  }
  span{
    width:200px;
    height:80px;
    background:rgba(23,64,218,1);
    border-radius:4px;
    margin-left:20px;
    color:#fff;
    font-size:32px;
    line-height:80px;
    text-align:center;
  }
}

</style>